import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { ButtonV2, Link } from '@zola/zola-ui';
import NewTableFieldSet from '../NewTableFieldset/NewTableFieldset';

import { formatTableRequest } from '../../util/seatingChartUtils';

const AddTablesForm = ({ createChart }) => {
  const [disableAddTables, setDisableAddTables] = useState(true);
  const [numTables, setNumTables] = useState(0);
  const [numSeats, setNumSeats] = useState(0);
  const [tableData, setTableData] = useState([{ num_tables: '', num_seats: '' }]);

  const removeTableSet = index => setTableData(tableData.filter((el, i) => i !== index));

  const updateCounts = newData => {
    const data = newData.reduce(
      (acc, fieldset) => {
        const { numTables: oldTableVal, numSeats: oldSeatVal } = acc;
        const { num_tables: tableVal, num_seats: seatVal } = fieldset;
        return tableVal !== '' && seatVal !== ''
          ? {
              numTables: parseInt(tableVal, 10) + oldTableVal,
              numSeats: parseInt(tableVal, 10) * parseInt(seatVal, 10) + oldSeatVal,
            }
          : { numTables: oldTableVal, numSeats: oldSeatVal };
      },
      { numTables: 0, numSeats: 0 }
    );
    setNumTables(data.numTables);
    setNumSeats(data.numSeats);
  };
  const updateAddButton = () => {
    const hasBlanks = tableData.some(set => set.num_tables === '' || set.num_seats === '');
    setDisableAddTables(hasBlanks);
  };
  useEffect(() => {
    updateAddButton();
    updateCounts(tableData);
  }, [tableData]);

  const updateTableData = (index, newData) => {
    const data = tableData.map((item, i) => (i !== index ? item : newData));
    setTableData(data);
  };
  const handleSubmit = tables => createChart(formatTableRequest(tables));

  return (
    <>
      <div className="create--form__tables">
        {tableData.map((set, index) => (
          <NewTableFieldSet
            key={index}
            setIndex={index}
            setCount={tableData.length}
            data={set}
            onRemove={() => removeTableSet(index)}
            onChange={data => updateTableData(index, data)}
          />
        ))}
      </div>
      {numTables.length > 100 && (
        <p className="table-warning">You&apos;ve exceeded the max limit of 100 tables</p>
      )}
      {numSeats > 750 && (
        <p className="table-warning">You&apos;ve exceeded the max limit of 750 seats</p>
      )}
      <Link
        role="button"
        className="text-primary"
        onClick={() => setTableData(tableData.concat([{ num_tables: '', num_seats: '' }]))}
      >
        + Add another set of tables
      </Link>
      <div className="create--form__buttons">
        <ButtonV2 variant="secondary" onClick={() => handleSubmit([])}>
          Do This Later
        </ButtonV2>
        <ButtonV2 disabled={disableAddTables} onClick={() => handleSubmit(tableData)}>
          Add Tables
        </ButtonV2>
      </div>
    </>
  );
};

AddTablesForm.propTypes = {
  createChart: PropTypes.func.isRequired,
};

export default AddTablesForm;



// WEBPACK FOOTER //
// ./src/components/manage/seatingchart/ChartCreator/AddTablesForm/AddTablesForm.jsx